import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OpcaoMenu } from '../../domain/models/opcao-menu.model';
import { OpcaoMenuComIcone } from '../../domain/models/opcao-menu-com-icone.model';
import { EContrastType } from '../../domain/enums/contrast-type.enum';
import { FontHelperService } from 'src/app/services/helpers/font-helper.service';
import { Tema, TemaHelperService } from 'src/app/services/helpers/tema-helper.service';
import { Router, RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-segov-sigepo-header',
  standalone: true,
  imports: [
    NgbModule,
    RouterModule
  ],
  templateUrl: './segov-sigepo-header.component.html',
  styleUrl: './segov-sigepo-header.component.css'
})
export class SegovSigepoHeaderComponent implements OnInit {
  @Input() srcLogo?: string;
  @Input() altLogo?: string;
  @Input() menus: OpcaoMenu[] = [];
  @Input() menuAreaCliente!: OpcaoMenuComIcone;
  @Input() menuAutenticidade!: OpcaoMenu;
  @Input() menuTopo: OpcaoMenu[] = [];
  @Input() temas: Tema[] = [];

  @Output() clickContraste = new EventEmitter<EContrastType>();

  public defaultContrastIcon = true;

  constructor(private readonly router: Router,
    private readonly fontService: FontHelperService,
    private readonly temaService: TemaHelperService){
  }

  ngOnInit(): void {
    this.temaService.setTemas(this.temas);
    this.defaultContrastIcon = this.temaService.temaPadraoAtivo();

    document.addEventListener('click', (event) => {
      const hamburger = document.getElementById('hamburger') as HTMLElement;
      const menu = document.getElementById('menu-small') as HTMLElement;
      const target = event.target as HTMLElement;

      if (!hamburger.contains(target) && !menu.contains(target)) {
          menu.style.display = 'none';
        }
    });
  }

  public buttonAction(opcao: OpcaoMenu){
    if(opcao.customAction) opcao.customAction();
    else if(opcao.rotaExterna) window.open(opcao.rotaExterna, "_blank");
    else if(opcao.rota) this.router.navigate([opcao.rota], {queryParams: {dados: opcao.rotaParametros}});
    else if(opcao.rotaHref) this.router.navigate(['', opcao.rotaHref])
  }

  public aumentarTamanhoFonte(){
    this.fontService.changeSize('+');
  }

  public diminuirTamanhoFonte(){
    this.fontService.changeSize('-');
  }

  public trocarTema(){
    this.temaService.trocarTema();
    setTimeout(() => {
      this.defaultContrastIcon = this.temaService.temaPadraoAtivo();
      this.clickContraste.emit(this.temaService.indexAtual);
    }, 100);
  }

  // Funções para telas menores
  public toggleMenuHamburger(){
    const menu = document.getElementById('menu-small') as HTMLElement;
    menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
  }

  public abrirSubMenu(opcao: OpcaoMenu){
    const submenu = document.getElementById(opcao.nome)?.getElementsByClassName('submenu-small')[0] as HTMLElement;
    if(submenu){
      submenu.style.borderTop = submenu.style.display === 'block' ? 'none' : 'solid 8px var(--tom-1-jornal)'
      submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
    }
  }
}
